const jhsmorninggloryWidgetData = [
  {
    songTitle: "808 Drive",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_808_drive_on.mp3?v=1743984122",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_808_drive_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/81e719aed3b14f0f9415c063bdbe61f5.mp4"
  },
  //{
  //  songTitle: "Dirty Bass",
  //  on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_dirty_bass_on.mp3?v=1743984122",
  //  off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_dirty_bass_off.mp3?v=1743984123",
  //  video: "https://cdn.shopify.com/videos/c/o/v/d0317e53dcab439997d2b267b1eebbca.mp4"
  //},
  {
    songTitle: "Drum Bus Drive",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_drum_bus_drive_on.mp3?v=1743984123",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_drum_bus_drive_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/a19943c15d9b4aa49c3c166bb689b11c.mp4"
  },
  {
    songTitle: "EJ  Fuzz",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_ej_fuzz_on.mp3?v=1743984122",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_ej_fuzz_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/56bb7f6b06ab44238367f0ee36d95185.mp4"
  },
  {
    songTitle: "Piano Dirt",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_piano_dirt_on.mp3?v=1743984123",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_piano_dirt_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/faacb4deadfb4a64b7ef2c6779127167.mp4"
  },
  {
    songTitle: "Synth Push",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_synth_push_on.mp3?v=1743984122",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_synth_push_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/6f6404c7e3dc4962b12fc344c1e8da5e.mp4"
  },
  {
    songTitle: "Vocal Grit",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_vocal_grit_on.mp3?v=1743984123",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_morningglory_vocal_grit_off.mp3?v=1743984123",
    video: "https://cdn.shopify.com/videos/c/o/v/035da7a215b7492c8cb2e7ea7da61604.mp4"
  }
];
